import api from "./api";

class StaffCallApi extends api {
  constructor() {
    super();
    this.setup();
  }

  store() {
    return this.post('staff', {});
  }
}

export default new StaffCallApi();
